import axios from "axios";
import ConvertObjectParamToString from "@/commons/ConvertObjectParamToString";
//const baseUrl = location.hostname === "localhost" || location.hostname === "127.0.0.1" ? "http://192.168.1.240:10005" : "";
// const baseUrl = "https://qltp.adfilex.vn";
//const baseUrl = "https://baocaodieuhanh.vnta.gov.vn";
export default class LoginApi {
  private convertObjectParamToStrings: ConvertObjectParamToString = ConvertObjectParamToString.instance;
  public Login(query: any): Promise<any> {
    // console.log("SERVER_API_UR -1", process.env.SERVER_API_URL);
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`/api/auth/login`, query)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  public LoginV2(query: any): Promise<any> {
    // console.log("SERVER_API_UR -1", process.env.SERVER_API_URL);
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`/api/auth/authenticate`, query)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public dowloadfile(file) {
    let id = file.file_id;
    var a = document.createElement("a");
    a.href = `/api/file/download/${id}`;
    a.download = file.name;
    a.click();
  }
}
